import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { PhoneNumberInput } from "../inputs/PhoneNumberInput";

type FormPhoneNumberProps<TFieldValues extends FieldValues, TTransformedValues = TFieldValues> = {
	className?: string;
	control: Control<TFieldValues, any, TTransformedValues>;
	name: Path<TFieldValues>;
	errorMessage?: string;
	compact?: boolean;
	readonly?: boolean;
};

export const FormPhoneNumber = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>(
	props: FormPhoneNumberProps<TFieldValues, TTransformedValues>,
) => {
	return (
		<Controller
			{...props}
			render={({ field: { ref, ...field }, fieldState }) => {
				const { value, onChange, ...fieldProps } = field;
				return (
					<PhoneNumberInput
						{...props}
						{...fieldProps}
						// The input reports the country's dial code even before anything is typed,
						// which would read as a malformed number rather than an unfilled field.
						onChange={(phone, meta) => onChange(meta.inputValue.trim() === "" ? "" : phone)}
						error={fieldState.error}
					/>
				);
			}}
		/>
	);
};
